export default __webpack_public_path__ + "static/media/sanko-enerji-logo-mobile.49b20d15.svg";